import { breakpoint } from 'helpers'

const heroNumbers = {
  el: {
    heroNumbers: <NodeListOf<HTMLElement>>document.querySelectorAll('.hero-numbers'),
  },

  init(): void {
    if (!this.el.heroNumbers.length) return

    this.el.heroNumbers.forEach((heroNumbers: HTMLElement) => {
      this.adjustBackground(heroNumbers)
      this.positionShapes(heroNumbers)
      window.addEventListener('resize', () => {
        this.adjustBackground(heroNumbers)
        this.positionShapes(heroNumbers)
      })
    })
  },

  isDesktop(): boolean {
    return window.innerWidth >= breakpoint.tablet
  },

  adjustBackground(heroNumbers: HTMLElement): void {
    const background = <HTMLElement>heroNumbers.querySelector('.hero-numbers__background')
    const infoItems = <HTMLElement>document.querySelector('.hero__slides--info-items')

    if (!background || !infoItems) return

    const infoItemsHeight = infoItems.offsetHeight

    if (this.isDesktop()) {
      background.style.marginTop = `${-infoItemsHeight / 2}px`
    } else {
      background.removeAttribute('style')
    }
  },

  positionShapes(heroNumbers: HTMLElement): void {
    const numbers = <HTMLElement>heroNumbers.querySelector('.hero-numbers__numbers')
    const shapes = <HTMLElement>heroNumbers.querySelector('.hero-numbers__shapes')

    if (!numbers || !shapes) return

    const containerHeight = heroNumbers.offsetHeight
    const numbersHeight = numbers.offsetHeight

    if (!this.isDesktop()) {
      shapes.style.top = `${containerHeight - numbersHeight}px`
    } else {
      shapes.removeAttribute('style')
    }
  },
}

export default heroNumbers
